import React from "react";
import CreateUser from "./CreateUser";
import CreateDoctor from "./CreateDoctor";
import CreatePatient from "./CreatePatient";

export default function Controller(props) {
  switch (props.mode) {
    case "patient":
      return <CreatePatient {...props} />;
    case "doctor":
      return <CreateDoctor {...props} />;
    default:
      return <CreateUser {...props} />;
  }
}
